import "../../../../styles/dashboard.css";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Autocomplete,
  FormControl,
  FormHelperText,
  TextField,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { format } from "date-fns";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import api, { wsURL } from "../../../../../../api/api";
import Datetime from "react-datetime";
import BackButton from "../../../../../../components/BackButton/BackButton";
import {
  Regenerate_course_image,
  vector,
  autorenew,
} from "../../../../../../assets/images/images";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import { isRequired } from "../../../../../../utils/validator";
import { Waveform } from "@uiball/loaders";
import OutlineFIleInput from "../../../../../../components/styledComponents/OutlineButton";
import { compressImage } from "../../../../../../utils/CompressImage";
import CropProfileImageModal from "../../CropProfileImageModal";
import FilteredTextField from "../../../../../../components/FilteredInput/FilteredTextField";
import Calimg from "../../../../../../assets/images/calendar.png";
import { ReactSVG } from "react-svg";
import {
  Course_created_successfully_image,
  Course_description_inner_ai_image,
  close,
} from "../../../../../../assets/images/images";
import {
  courseImageGenerateDtl,
  resetCourseImageGenerate,
} from "../../../../../../state/actions/courseImageGenerateAction";
import FloatingAIButton from "../../../../../../components/FloatingAIButton/FloatingAIButton";
import {
  setDrawerState,
  setIsWebAllowed,
  setQueryMetaData,
} from "../../../../../../state/reducers/chatDrawerReducers";
import { Tooltip } from "react-tooltip";
import { getPlatformFee } from "../../../../../../state/actions/getPlatformFeeAction";
import {getFreeDomain} from "../../../../../../state/actions/getFreeDomainAction";
import "./Styles/course.css";
import restrichtion_icon from "../../../../../../assets/images/restrichtion.svg";
import { useRef } from "react";
import "./EditCourseDetails.css";

const EditCourseDetails = () => {
  const [changeImageUploadText, setChangeImageUploadText] = useState(false);
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
    const freedomain  = useSelector((state)=> state.getfreeDomain.freedomain ?? []);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const globalState = useSelector((state) => state.globalState);
  const { token } = useAuth();
  let { id } = useParams();
    const email = globalState?.email || "";

const isValidDomain =
  email.endsWith("@arcitech.ai") ||
  email.endsWith("@arcotgroup.com") ||
  email.endsWith("@webarcitech.com");


    const [selectedDomains, setSelectedDomains] = useState(JSON.parse(localStorage.getItem("courseDetails"))?.free_domains ?? []);
    const [showDropdown, setShowDropdown] = useState(false);
  
    const handleSelectAll = (e) => {
      if (e.target.checked) {
        setSelectedDomains(freedomain);
      } else {
        setSelectedDomains([]);
      }
    };
  
    const handleCheckboxChange = (domain) => {
      setSelectedDomains((prev) =>
        prev.includes(domain)
          ? prev.filter((item) => item !== domain)
          : [...prev, domain]
      );
    };


  // ─── Step 1: Persist incoming course to localStorage once on mount ───────────
  useEffect(() => {
    if (Object.keys(location.state?.course || {}).length !== 0) {
      localStorage.setItem(
        "courseDetails",
        JSON.stringify(location.state?.course),
      );
    }
  }, []);

  // ─── Stable reference: read once, never changes between renders ─────────────
  // NOTE: This is read synchronously so all useState initialisers below get the
  //       correct value on the very first render, before any effect fires.
  const course = JSON.parse(localStorage.getItem("courseDetails")) || {};

  const teacher_id =
    location.state?.teacher_id ??
    globalState.teacher_details?.data?.teacher_id ??
    "";

  const [loading, setLoading] = useState(false);
  const [imageUploaded, setImageUploaded] = useState(false);

  // ─── Step 2: Initialise isMonetizeEnabled directly from `course` ─────────────
  // This is correct on first render because `course` is read synchronously above.
  // The problematic `useEffect([course])` that kept resetting this on every render
  // has been removed — it was creating a new object reference each render (since
  // JSON.parse always returns a new object) and therefore ran after every toggle,
  // overwriting the user's selection.
  const [isMonetizeEnabled, setIsMonetizeEnabled] = useState(!!course?.price);

  // ─── Step 3: Sync formState AND isMonetizeEnabled from localStorage (once) ───
  // This single effect replaces both the old "load formState" effect and the
  // removed "[course]" effect. It runs once on mount, after localStorage has been
  // updated by the first effect above (React batches effects in order).
  useEffect(() => {
    const storedCourse = JSON.parse(localStorage.getItem("courseDetails"));
    if (storedCourse) {
      setSelectedImage(storedCourse.image);
      setTempImage(storedCourse.image);
      setUplodedImage(storedCourse.image);

      // Sync monetize flag with the freshly stored course data
      setIsMonetizeEnabled(!!storedCourse.price);
      setSelectedDomains(storedCourse?.free_domains ?? []);


      setFormState((prev) => ({
        name: storedCourse?.name ?? "",
        start_date: storedCourse?.start_date ?? "",
        end_date: storedCourse?.end_date ?? "",
        // Normalize CRLF -> LF so the character count matches the create-course
        // component and what the browser textarea produces on typing.
        description: (storedCourse?.description ?? "").replace(/\r\n/g, "\n"),
        image: storedCourse?.image ?? "",
        image_url: "",
        teacher: teacher_id,
        is_active: true,
        price: storedCourse?.price ?? "",
        discount_percentage: storedCourse?.discount_percentage ?? "",
        from_grade:
          typeof storedCourse?.from_grade === "object"
            ? Object.keys(storedCourse?.from_grade ?? "")
            : typeof from_grade === "string"
              ? (storedCourse?.from_grade ?? "")
              : "",
        to_grade:
          typeof storedCourse?.to_grade === "object"
            ? Object.keys(storedCourse?.to_grade ?? "")
            : typeof to_grade === "string"
              ? (storedCourse?.to_grade ?? "")
              : "",
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // ← empty deps: run once on mount only

  const [selectedImage, setSelectedImage] = useState(
    JSON.parse(localStorage.getItem("courseDetails"))?.image ?? "",
  );
  const [clickCount, setClickCount] = useState(
    Number(localStorage.getItem("clickCount")) || 0,
  );
  const [getSocket, setSocket] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isRegenerate, setIsRegenerate] = useState(false);
  const [imageUploading, setImageUploading] = useState(false);
  const getcourseImage = useSelector((state) => state.getcourseImage);
  const { platformfee } = useSelector((state) => state.platformFee);
  const currency_symbol = useSelector(
    (state) => state?.globalState?.currency_symbol,
  );
  const [discountedAmt, setdiscountedAmt] = useState("");
  const [commission, setcommission] = useState("");
  const [finalAmt, setfinalAmt] = useState("");
  const [tempImage, setTempImage] = useState(course?.image ?? "");
  const [uplodedImage, setUplodedImage] = useState(course?.image ?? "");

  const teacherSubjects = globalState?.teacher_details?.data?.subjects;
  const subjectsArray = teacherSubjects
    ? Object.entries(teacherSubjects)
      .map(([key, value]) => ({ key, value }))
      .sort((a, b) => a.value.localeCompare(b.value))
    : [];
  subjectsArray.push({ key: "others", value: "Others" });
  const [createLoading, setCreateLoading] = useState(false);
  const [waveloading, setwaveloading] = useState(false);
  const [formState, setFormState] = useState({
    name: course?.name ?? "",
    start_date: course?.start_date ?? "",
    end_date: course?.end_date ?? "",
    description: (course?.description ?? "").replace(/\r\n/g, "\n"),
    image: course?.image ?? "",
    image_url: "",
    teacher: teacher_id,
    is_active: true,
    price: course?.price ?? "",
    discount_percentage: course?.discount_percentage ?? "",
    domains: course?.domains ?? [],
    from_grade:
      typeof course?.from_grade === "object"
        ? Object.keys(course?.from_grade ?? "")
        : typeof from_grade === "string"
          ? (course?.from_grade ?? "")
          : "",
    to_grade:
      typeof course?.to_grade === "object"
        ? Object.keys(course?.to_grade ?? "")
        : typeof to_grade === "string"
          ? (course?.to_grade ?? "")
          : "",
  });

  const [formErrors, setFormErrors] = useState({
    name: "",
    subject: "",
    from_grade: "",
    to_grade: "",
    start_date: "",
    end_date: "",
    description: "",
    image: "",
    price: "",
    discount_percentage: "",
    discounted_price: "",
  });

  const discountArr = [
    5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95,
  ];
  const transformedDiscountArr = discountArr.map((discount) => `${discount}%`);

  // useEffect(() => {
  //   const price = Number(formState.price);
  //   const discountPct = Number(form State.discount_percentage) || 0;
  //   if (!price || isNaN(price)) {
  //     setdiscountedAmt("");
  //     setcommission("");
  //     setfinalAmt("");
  //     return;
  //   }
  //   const discountAmt = price - (price * discountPct) / 100;
  //   setdiscountedAmt(discountAmt.toFixed(2));
  //   const pct = Number(platformfee) || 0;
  //   const commissionVal = (discountAmt * pct) / 100;
  //   setcommission(commissionVal.toFixed(2));
  //   const amountAfterComm = discountAmt - commissionVal;
  //   setfinalAmt(amountAfterComm.toFixed(2));
  // }, [formState.price, formState.discount_percentage, platformfee]);




  // useEffect(() => {
  //   const price = Number(formState.price);
  //   const discountPct = Number(form State.discount_percentage) || 0;
  //   if (!price || isNaN(price)) {
  //     setdiscountedAmt("");
  //     setcommission("");
  //     setfinalAmt("");
  //     return;
  //   }
  //   const discountAmt = price - (price * discountPct) / 100;
  //   setdiscountedAmt(discountAmt.toFixed(2));
  //   const pct = Number(platformfee) || 0;
  //   const commissionVal = (discountAmt * pct) / 100;
  //   setcommission(commissionVal.toFixed(2));
  //   const amountAfterComm = discountAmt - commissionVal;
  //   setfinalAmt(amountAfterComm.toFixed(2));
  // }, [formState.price, formState.discount_percentage, platformfee]);


  //new round off logic
  const [roundOffValue, setRoundOffValue] = useState(0);


  useEffect(() => {
    if (globalState.enabled_modules?.includes("marketplace")) {
      const price = Number(formState.price || 0);
      const discountPercentage = Number(formState.discount_percentage || 0);

      // Original discounted amount
      let discountAmt = price - (price * discountPercentage) / 100;

      let finalDiscountAmt = discountAmt;
      let roundOff = 0;

      // Apply round-off ONLY for USD
      // if (currency_symbol === "$") {
        finalDiscountAmt = Math.round(discountAmt);
        roundOff = finalDiscountAmt - discountAmt;
      // }

      // setdiscountedAmt(finalDiscountAmt.toFixed(2));
      setdiscountedAmt(finalDiscountAmt);

      setRoundOffValue(roundOff.toFixed(2));

      const commissionVal = (finalDiscountAmt * platformfee) / 100;
      setcommission(commissionVal.toFixed(2));

      const amountAfterComm = finalDiscountAmt - commissionVal;
      setfinalAmt(amountAfterComm.toFixed(2));
    }
  }, [
    formState.price,
    formState.discount_percentage,
    platformfee,
    currency_symbol,
  ]);

  //new roundoff logic (sonny sir requirements)
//   useEffect(() => {
//   const price = Number(formState.price);
//   const discountPct = Number(formState.discount_percentage) || 0;

//   if (!price || isNaN(price)) {
//     setdiscountedAmt("");
//     setcommission("");
//     setfinalAmt("");
//     return;
//   }

//   const roundOff = (val) => Math.round(val); // ← whole number rounding

//   const discountAmt = roundOff(price - (price * discountPct) / 100);
//   setdiscountedAmt(discountAmt);

//   const pct = Number(platformfee) || 0;
//   const commissionVal = roundOff((discountAmt * pct) / 100);
//   setcommission(commissionVal);

//   const amountAfterComm = roundOff(discountAmt - commissionVal);
//   setfinalAmt(amountAfterComm);
// }, [formState.price, formState.discount_percentage, platformfee]);

  useEffect(() => {
    if (globalState.enabled_modules?.includes("marketplace")) {
      dispatch(getPlatformFee(token)); 
      dispatch(getFreeDomain(token));
      
    }
  }, []);

  // ─── REMOVED: useEffect(() => { setIsMonetizeEnabled(...) }, [course]) ────────
  // Root cause: `course` was `JSON.parse(...)` defined at component scope, so it
  // produced a new object reference on every render. React saw the dependency as
  // "changed" every render, causing the effect to fire after every toggle and
  // reset `isMonetizeEnabled` back to the original value from localStorage.

  const validateCoursePrice = (value) => {
    const priceString = String(value ?? "").trim();
    const Courseprice = parseFloat(Number(priceString).toFixed(2));

    if (isNaN(Courseprice)) return "Enter a valid course price";
    if (!priceString) {
      return "This field is required";
    }

    const price = Number(priceString);

    if (Number.isNaN(price)) {
      return "Enter a valid course price";
    }

    if (!Number.isInteger(price)) {
      return "Course price must be a whole number";
    }

    if (currency_symbol) {
      if (currency_symbol === "₹") {
        if (price > 100000) {
          return "Price must not be more than ₹100000";
        } else if (price < 99) {
          return "Price must be ₹99 or higher";
        }
      }
      else if (currency_symbol === "$") {
        if (price > 5000) {
          return "Price must not be more than $5000";
        } else if (price < 1) {
          return "Price must be $1 or higher";
        }
      }
    }

    return "";
  };

  const actualDiscountAmt =
    Number(formState.price || 0) -
    (Number(formState.price || 0) *
      Number(formState.discount_percentage || 0)) /
    100;

  const validateDiscountedPrice = (discounted, actualDiscountAmt) => {
    const amt = Number(actualDiscountAmt || discountedAmt);
    if (!discounted || isNaN(amt)) return "";

    if (currency_symbol === "₹" && amt < 99) {
      return "Discounted price must be ₹99 or higher";
    }
    if (currency_symbol === "$" && amt < 1) {
      return "Discounted price must be $1 or higher";
    }
    return "";
  };

  const savedMonetizeValues = useRef({
    price: course?.price ?? "",
    discount_percentage: course?.discount_percentage ?? "",
  });

  const handleSwitchToggle = () => {
    const newState = !isMonetizeEnabled;
    setIsMonetizeEnabled(newState);
    if (!newState) {
      // Save current values before clearing so we can restore if toggled back on
      savedMonetizeValues.current = {
        price: formState.price,
        discount_percentage: formState.discount_percentage,
      };
      setFormState((prev) => ({
        ...prev,
        price: "",
        discount_percentage: "",
      }));
      setFormErrors((prev) => ({
        ...prev,
        price: "",
        discount_percentage: "",
      }));
    } else {
      // Restore saved values when toggling back ON
      setFormState((prev) => ({
        ...prev,
        price: savedMonetizeValues.current.price,
        discount_percentage: savedMonetizeValues.current.discount_percentage,
      }));
    }
  };

  const timestamp = Date.now();

  const newWebSocketURL = `${wsURL}ws/course_descrption/${timestamp}/?token=${token}`;

  let combinedMessage = [];
  // Create the WebSocket connection when the component mounts
  useEffect(() => {
    // Create a WebSocket connection with the new URL
    const socket = new WebSocket(newWebSocketURL);
    // Set the socket state variable
    setSocket(socket);

    // Event handler for when the WebSocket connection is established
    socket.addEventListener("open", (event) => { });
    document.body.style.overflow = "auto !important";
    // Event handler for incoming messages from the WebSocket server
    socket.addEventListener("message", (event) => {
      try {
        const data = JSON.parse(event.data);

        if (data && data.message) {
          const message = data.message;

          combinedMessage.push(message);
          let status = false;
          let chatdatares = combinedMessage.join("");

          if (
            chatdatares.includes("<STARTOFTURN>") ||
            chatdatares.includes("<ENDOFTURN>")
          ) {
            chatdatares = chatdatares
              .replace(/<STARTOFTURN>/g, "")
              .replace(/<ENDOFTURN>/g, "");

            if (combinedMessage.join("").includes("<ENDOFTURN>")) {
              status = true;
              combinedMessage.length = 0;
              combinedMessage.push(chatdatares);
            }
          }
          setFormState((prev) => {
            if (status) {
              combinedMessage.length = 0;
            }
            return {
              ...prev,
              description: chatdatares
                .replace("<STARTOFTURN>", "")
                .replace("<ENDOFTURN>", "")
                .replace(/\r\n/g, "\n"),
            };
          });

          setwaveloading(false);
          setFormErrors((prevErrors) => ({ ...prevErrors, description: "" }));
        } else {
          setwaveloading(false);
        }
      } catch (error) {
        setwaveloading(false);
      }
    });
    socket.addEventListener("close", (event) => { });
    socket.addEventListener("error", (error) => { });

    return () => {
      if (socket.readyState === 1) {
        socket.close();
      }
    };
  }, []);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const isValidStartDate = (current) => {
    const today = dayjs().startOf("day"); // Today at 00:00
    return current.isSameOrAfter(today); // Allow today and future dates
  };

  const isValidEndDate = (current) => {
    // Ensure there's a start date selected
    if (!formState.start_date) {
      return false; // Disable all dates if no start date is selected
    }

    // Calculate the minimum end date as one day after the start date
    const minEndDate = dayjs(formState.start_date).add(1, "day");
    return dayjs(current).isAfter(minEndDate, "day"); // 'isAfter' will ensure the date is at least the day after minEndDate
  };

  const onOpenModal = () => {
    setModalIsOpen(true);
  };

  const onCloseModal = (saveChanges) => {
    if (saveChanges) {
      setUplodedImage(tempImage);
    } else {
      setSelectedImage(uplodedImage);
    }
    setModalIsOpen(false);
  };

  const handleSaveCroppedImage = (croppedImage) => {
    setTempImage(croppedImage);
    onCloseModal(true);
  };

  const handleCancelCroppedImage = () => {
    onCloseModal(false);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    let error = "";
    if (name === "name") {
      error = isRequired(value);
      // Allow typing but show error when restricted chars are present
      if (/[+%&#]/.test(value)) {
        error = "Characters + % & # are not allowed";
      }

      setFormErrors((prev) => ({ ...prev, [name]: error }));
      setFormState((prev) => ({ ...prev, [name]: value })); // keep raw value
      return;

    } else if (name === "description") {
      error = isRequired(value);
    } else if (name === "from_grade") {
      error = isRequired(value);
    } else if (name === "to_grade") {
      error = isRequired(value);
    } else if (name === "subject") {
      error = isRequired(value);
    } else if (name === "start_date") {
      error = isRequired(value);
    } else if (name === "price" && isMonetizeEnabled) {
      error = validateCoursePrice(value);
    }
    // else if (name === 'end_date') {
    //     error = isRequired(value);
    // }
    else if (name === "image") {
      error = isRequired(value);
    }
    setFormErrors({
      ...formErrors,
      [name]: error,
    });
    setFormState((prev) => ({ ...prev, [name]: value }));
  };
  const YYYYMMDD = (date) => {
    try {
      return format(new Date(date ?? ""), "yyyy-MM-dd");
    } catch (error) {
      return "";
    }
  };

  const handleInputChangedate = (name, value) => {
    let error = "";
    if (name === "start_date") {
      error = isRequired(YYYYMMDD(value));
    }
    setFormErrors({
      ...formErrors,
      [name]: error,
    });
    if (YYYYMMDD(value)) {
      setFormState((prev) => ({
        ...prev,
        [name]: YYYYMMDD(value),
      }));
    } else {
      setFormState((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    const failedErrorMessage =
      "Oops, something went wrong. Please try again later.";

    if (getcourseImage?.message) {
      toast.success(getcourseImage.message, {
        position: "top-center",
      });

      setImageUploaded(true);
      setSelectedImage(getcourseImage.message.image_urls);
      setUplodedImage(getcourseImage.message.image_urls);

      setFormState((prev) => ({
        ...prev,
        image_url: getcourseImage.message.image_urls,
        image: null,
      }));
      setClickCount(clickCount + 1);
      setFormState((prev) => ({ ...prev, image_type: 1 }));
      setIsRegenerate(false);
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        image: "",
        image_url: "",
      }));
      dispatch(resetCourseImageGenerate());
    } else if (getcourseImage?.error) {
      toast.error(getcourseImage.error || failedErrorMessage, {
        position: "top-center",
      });
      dispatch(resetCourseImageGenerate());
    }
  }, [getcourseImage, dispatch]);

  useEffect(() => {
    localStorage.setItem("clickCount", clickCount);
  }, [clickCount]);

  useEffect(() => {
    return () => {
      localStorage.removeItem("clickCount");
      dispatch(resetCourseImageGenerate());
    };
  }, []);
  const generatesImges = async () => {
    setChangeImageUploadText(false);
    if (clickCount >= 3) {
      setErrorMessage(
        "The AI image generation has reached its three-attempt limit.",
      );
      return;
    }

    setImageUploaded(false);
    setIsRegenerate(true);
    setSelectedImage(null);
    const formdata = {
      Course_name: formState.name || "",
      Subject: getSubjectData(course.subject),
      Grade: `${gradeArray.find((grd) => grd.key === formState.from_grade[0])?.value ??
        ""
        }-${gradeArray.find((grd) => grd.key === formState.to_grade[0])?.value ?? ""
        }`,
      Course_description: formState.description || "",
    };
    dispatch(courseImageGenerateDtl(formdata));
  };
  function EnhancedDescription({
    courseName,
    subject,
    from_grade,
    to_grade,
    keywords,
  }) {
    // Function to enhance the description  using the WebSocket connection
    const enhanceDescription = (e) => {
      e.preventDefault();
      setwaveloading(true);

      if (getSocket) {
        // Create a JSON payload to send over the WebSocket
        const payload = {
          course_name: courseName,
          subject: subject,
          start_grade:
            gradeArray.find((grd) => grd.key === from_grade)?.value ?? "",
          end_grade:
            gradeArray.find((grd) => grd.key === to_grade)?.value ?? "",
          keywords: keywords,
        };
        const payloadJSON = JSON.stringify(payload);

        // Send the JSON data over the WebSocket connection
        getSocket.send(payloadJSON);
      }
      // Add functionality to enhance the description here
    };

    return (
      <button
        onClick={enhanceDescription}
        type="button"
        disabled={
          !formState.name ||
          !course.subject ||
          !formState.from_grade ||
          !formState.to_grade ||
          !formState.start_date ||
          waveloading
        }
        className="Course-description-inner-ai-feilds"
      >
        <div className="Course-description-inne r-ai-image">
          <img src={Course_description_inner_ai_image} alt="" />
        </div>
        <span>Enhance Course Description</span>
      </button>
    );
  }

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleFileInput = async (event) => {
    setFormState((prev) => ({ ...prev, image_type: "" }));
    // Show loader when file input is created
    setImageUploading(true);
    setSelectedImage(null);
    // Reset imageUploaded to false whenever a new file is selected
    setImageUploaded(false);

    const file = event.target.files[0];
    if (file) {
      try {
        // Compress the image
        const compressedImage = await compressImage(file);

        const base64Image = await toBase64(compressedImage);
        // localStorage.setItem('selectedImage', base64Image);
        setSelectedImage(base64Image);

        // setSelectedImage(URL.createObjectURL(compressedImage));

        // Set the temporary image to be potentially cropped and saved
        setTempImage(URL.createObjectURL(compressedImage));

        onOpenModal();

        setFormErrors({
          ...formErrors,
          image: "",
        });
        setFormState((prev) => ({ ...prev, image_type: 2 }));
      } catch (error) {
        console.error("Image compression failed:", error);
        setSelectedImage(null);
        // Handle error and set form error
        setFormErrors({
          ...formErrors,
          image: "Image compression failed.",
        });
      } finally {
        // Hide loader when compression is complete
        setImageUploading(false);
      }
    } else {
      setSelectedImage(null);
      // Hide loader when no file is selected (cancel)
      setImageUploading(false);
    }
  };
  const getSubjectData = (subject) => {
    if (typeof subject === "object" && subject !== null) {
      const firstKey = Object.keys(subject)[0];
      return subject[firstKey];
    } else if (typeof subject === "string") {
      return subject;
    } else {
      return "";
    }
  };
  const onViewCourseClick = async (course) => {
    navigate(`/course/${course.course_id}/view`, {
      state: { course, teacher_id },
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = {};

    errors.name = isRequired(formState.name);
      // Block restricted characters (covers courses loaded from localStorage
      // whose names were created before this restriction existed)
      if (/[+%&#]/.test(formState.name)) {
        errors.name = "Characters + % & # are not allowed";
      }
    errors.start_date = isRequired(formState.start_date);
    errors.description = isRequired(formState.description);
    if (formState.image_type === 2) {
      errors.image = isRequired(formState.image);
    } else if (formState.image_type === 1) {
      errors.image = isRequired(formState.image_url);
    } else {
      if (formState.image === "" && formState.image_url === "") {
        errors.image = isRequired(
          formState.image === "" ? formState.image : formState.image_url,
        );
      }
    }
    if (
      globalState.enabled_modules?.includes("marketplace") &&
      isMonetizeEnabled
    ) {
      errors.price = isMonetizeEnabled
        ? validateCoursePrice(formState.price)
        : "";
      errors.discounted_price = isMonetizeEnabled          // ← add this
        ? validateDiscountedPrice(discountedAmt, actualDiscountAmt)
        : "";
    }

    setFormErrors(errors);
    if (!Object.values(errors).some((error) => error)) {
      await onEditCourse();
    }
  };
  const onEditCourse = async () => {
    setLoading(true);
    toast.dismiss();
    let name = formState.name;
    let description = formState.description;
    let end_date = formState.end_date;
    let start_date = formState.start_date;
    let image = formState.image;
    let image_url = formState.image_url;
    let to_grade = formState.to_grade;
    let from_grade = formState.from_grade;
    let payload = new FormData();

    if (end_date && end_date !== course?.end_date) {
      payload.append("end_date", end_date);
    } else if (!end_date) {
      // Here you can decide whether to append a null value or not append the end_date at all
      payload.append("end_date", ""); // or payload.append('end_date', null);
    }

    if (name !== course?.name) payload.append("name", name);
    if (description !== course?.description)
      payload.append("description", description);
    if (start_date !== course?.start_date)
      payload.append("start_date", start_date);
    if (image !== uplodedImage && !image_url) payload.append("image", image);
    if (image_url) payload.append("image_url", image_url);
    if (to_grade !== course?.to_grade) payload.append("to_grade", to_grade);
    if (from_grade !== course?.from_grade)
      payload.append("from_grade", from_grade);
    // Marketplace: price and discount bb:data lena hai backed se aur display karna hai frontend me , and update karte samay bhi proper append karna hai 
    if (globalState.enabled_modules?.includes("marketplace")) {
      if (!isMonetizeEnabled) {
        payload.append("price", "");
        payload.append("discount_percentage", "");  
    payload.append("free_domains", JSON.stringify([]));
      } else {
        if (
          formState.price !== undefined &&
          formState.price !== "" &&
          String(formState.price) !== String(course?.price)
        ) {
          payload.append("price", formState.price);
        }
        if (
          formState.discount_percentage !== undefined &&
          String(formState.discount_percentage) !==
          String(course?.discount_percentage ?? "")
        ) {
          payload.append("discount_percentage", formState.discount_percentage);
        }
        // Monetize ON → append free_domains only if it actually changed
    const existingDomains = course?.free_domains ?? [];
    const domainsChanged =
      JSON.stringify([...selectedDomains].sort()) !==
      JSON.stringify([...existingDomains].sort());
    if (domainsChanged) {
      payload.append("free_domains", JSON.stringify(selectedDomains));
    }
      }
    }
    payload.append("push_to_schoology", true);

    try {
      const response = await api.put(`/courses/update-course/${id}/`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${token}`,
        },
      });
      if (response.status === 200 || response.status === 201) {
        onViewCourseClick(response?.data?.data);
        toast.success("Course updated successfully.", {
          position: "top-center",
        });
        localStorage.removeItem("clickCount");
        setLoading(false);

        // Update location.state.course with new values, keep rest as-is
        // navigate(location.pathname, {
        //   replace: true,
        //   state: {
        //     ...location.state,           // keep all existing state
        //     course: response?.data?.data  // update only course
        //   }
        // });
        onViewCourseClick(response?.data?.data);
      } else {
        toast.error("Failed to update course.", {
          position: "top-center",
        });
        setLoading(false);
      }
    } catch (error) {
      toast.error("Failed to update course.", {
        position: "top-center",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  let grade_details;
  try {
    grade_details = globalState.grade_details?.grade;
  } catch (error) { }
  const gradeArray =
    grade_details && grade_details
      ? Object.entries(grade_details).map(([key, value]) => ({ key, value }))
      : [];

  const getKeyByvalue = (value) => {
    if (value) {
      const item = gradeArray.find((obj) => obj.value === value);
      const key = item ? item.key : null;
      return key;
    } else {
      return "";
    }
  };
  function getToGradeArray(from_grade, grades) {
    let to_grade_array = [];

    // Determine the starting grade key
    let startGradeKey;
    if (Array.isArray(from_grade) && from_grade.length > 0) {
      startGradeKey = from_grade[0];
    } else {
      startGradeKey = from_grade;
    }

    // If startGradeKey is not determined or invalid, return an empty array
    if (!startGradeKey || isNaN(startGradeKey)) return [];

    // Populate to_grade_array
    for (let key in grades) {
      if (parseInt(key) >= parseInt(startGradeKey)) {
        to_grade_array.push({ key: key, value: grades[key] });
      }
    }
    return to_grade_array;
  }
  const [open1, setopen1] = useState(false);
  const [open2, setopen2] = useState(false);

  const resetEndDate = () => {
    setFormState((prev) => ({
      ...prev,
      end_date: null, // Reset to null or empty string depending on how your state is expected
    }));
  };

  const handleCancelClick = () => {
    navigate(-1);
  };

  useEffect(() => {
    // if (isMonetizeEnabled && discountedAmt) {
    if (isMonetizeEnabled) {
      const amountToValidate =
        actualDiscountAmt !== undefined &&
          actualDiscountAmt !== null &&
          actualDiscountAmt !== ""
          ? actualDiscountAmt
          : discountedAmt;
      setFormErrors((prev) => ({
        ...prev,
        discounted_price: validateDiscountedPrice(amountToValidate),
      }));
    }
  }, [discountedAmt, actualDiscountAmt, isMonetizeEnabled]);




  const isDiscountDisabled =
    currency_symbol === "$" && Number(formState.price) === 1;

  return (
    <>
      <div className="dashboard" id="edit-course-Details-section">
        <form
          className="edit-course-Details-wrapper"
          action=""
          onSubmit={handleSubmit}
        >
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="view-course-Details-back-btn-folder">
                  <BackButton buttonName={"Back"} />
                </div>
                <div className="edit-course-details-container">
                  <div className="edit-course-details-folder">
                    <div className="uploded-image-section">
                      <FormControl
                        className="edit-course-form-control"
                        margin="none"
                        fullWidth
                        error={!!formErrors.image}
                        style={{ position: "relative" }}
                      >
                        <div className="Create-Course-image">
                          {uplodedImage ? (
                            <>
                              <div className="course-main-image">
                                <img
                                  className="course-uploded-image"
                                  style={{ maxHeight: "270px" }}
                                  src={
                                    imageUploaded ? selectedImage : uplodedImage
                                  }
                                  alt=""
                                />
                              </div>
                            </>
                          ) : (
                            <div
                              className="course-file-image"
                              style={
                                !!formErrors.image
                                  ? { border: "2px #d32f2f dashed" }
                                  : null
                              }
                            />
                          )}

                          <div className="Create-Course-uplode-image-container">
                            {!uplodedImage && (
                              <>
                                <div className="Create-Course-uisng-ai">
                                  {isRegenerate && (
                                    <img
                                      className={`loding ${isRegenerate ? "spinning" : ""
                                        }`}
                                      src={autorenew}
                                      alt=""
                                    />
                                  )}
                                  <button
                                    type="button"
                                    onClick={generatesImges}
                                    className={`course-Generating-AI-btn`}
                                    disabled={
                                      !formState.name ||
                                      !formState.description ||
                                      !formState.from_grade ||
                                      !formState.start_date ||
                                      isRegenerate
                                    }
                                  >
                                    Generate using AI
                                  </button>
                                </div>
                                <div className="Create-Course-uisng-ai uplode-image">
                                  <OutlineFIleInput
                                    label={"Upload Image"}
                                    handleFileInput={handleFileInput}
                                  />
                                  {imageUploading && (
                                    <img
                                      className={` ${imageUploading ? "spinning" : ""
                                        }`}
                                      src={autorenew}
                                      alt=""
                                    />
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        {uplodedImage && (
                          <>
                            <div className="reuplode-image-folder flex-row items-center">
                              <div className="Regenerate-Course-image min-w-fit">
                                <img
                                  className={`Regenerate-image ${isRegenerate ? "spinning" : ""
                                    }`}
                                  src={autorenew}
                                  alt=""
                                />
                                <button
                                  disabled={
                                    !formState.name ||
                                    !formState.description ||
                                    !formState.from_grade ||
                                    !formState.start_date ||
                                    isRegenerate
                                  }
                                  onClick={generatesImges}
                                  type="button"
                                  className="Regenerate-course-btn"
                                >
                                  {changeImageUploadText
                                    ? "Generate"
                                    : "Regenerate"}
                                </button>
                              </div>
                              <div
                                className="Create-Course-uplode-outer-image"
                                style={
                                  isRegenerate
                                    ? { pointerEvents: "none", opacity: "0.5" }
                                    : {}
                                }
                              >
                                <OutlineFIleInput
                                  label={
                                    changeImageUploadText
                                      ? "Re-Upload Image"
                                      : "Upload Image"
                                  }
                                  handleFileInput={(e) => {
                                    setSelectedImage(null);
                                    handleFileInput(e);
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        )}
                        {errorMessage && (
                          <div className="limiterrorMessage">
                            <span>{errorMessage}</span>
                          </div>
                        )}

                        <FormHelperText>{formErrors.image}</FormHelperText>
                      </FormControl>
                    </div>
                    <div
                      className={`edit-course-details-right-section ${isMonetizeEnabled ? "" : "justify-center"} md:!w-full`}
                    >
                      <div className="edit-course-details-inner-input-container">
                        <div className="edit-Course-inner-input">
                          <div className="course-input-character-limit">
                            <label>Course Name</label>
                            <span style={{ fontSize: "10px" }}>
                              (Character limit: {formState.name.length || 0}/50)
                            </span>
                          </div>
                          <FormControl
                            className="edit-course-form-control"
                            margin="none"
                            fullWidth
                            error={!!formErrors.name}
                          >
                            <TextField
                              name="name"
                              placeholder="Eg. Fundamentals of Neuroscience"
                              variant="outlined"
                              size="small"
                              className="edit-course-input-fields"
                              value={formState.name}
                              error={!!formErrors.name}
                              onChange={handleInputChange}
                              InputProps={{
                                sx: {
                                  borderRadius: "6px",
                                  backgroundColor: "#FFFFFF",
                                  marginTop: "5px",
                                  height: "40px",
                                },
                                inputProps: { maxLength: 50 },
                              }}
                            />
                            <FormHelperText>{formErrors.name}</FormHelperText>
                          </FormControl>
                        </div>
                        <div className="create-course-Grade-input-folder">
                          <div
                            className="Create-Course-inner-input create-course-inner-input-grade"
                            style={{ marginTop: "5px" }}
                          >
                            <label>Level</label>
                            <FormControl
                              className="edit-course-form-control"
                              margin="none"
                              fullWidth
                              error={!!formErrors.from_grade}
                            >
                              <TextField
                                name="from_grade"
                                placeholder="Eg. SQL"
                                variant="outlined"
                                select
                                className="edit-course-input-fields"
                                size="small"
                                error={!!formErrors.from_grade}
                                value={formState.from_grade}
                                onChange={handleInputChange}
                                defaultValue={formState.from_grade || ""}
                                InputProps={{
                                  sx: {
                                    borderRadius: "6px",
                                    backgroundColor: "#FFFFFF",
                                    paddingRight: "0px",
                                    fontSize: "13px",
                                  },
                                }}
                              >
                                {gradeArray.map((option) => (
                                  <MenuItem
                                    key={`gradeArray1${option.key}`}
                                    value={option.key}
                                  >
                                    {option.value}
                                  </MenuItem>
                                ))}
                              </TextField>
                              <FormHelperText>
                                {formErrors.from_grade}
                              </FormHelperText>
                            </FormControl>
                          </div>
                          <div
                            className="Create-Course-inner-input create-course-inner-input-grade"
                            style={{ marginTop: "5px" }}
                          >
                            <label>To Level</label>
                            <FormControl
                              className="edit-course-form-control"
                              margin="none"
                              fullWidth
                              error={!!formErrors.to_grade}
                            >
                              <TextField
                                name="to_grade"
                                placeholder="Eg. SQL"
                                variant="outlined"
                                select
                                size="small"
                                className="edit-course-input-fields"
                                error={!!formErrors.to_grade}
                                value={formState.to_grade}
                                onChange={handleInputChange}
                                defaultValue={formState.to_grade || ""}
                                InputProps={{
                                  sx: {
                                    borderRadius: "6px",
                                    backgroundColor: "#FFFFFF",
                                    paddingRight: "0px",
                                    fontSize: "13px",
                                  },
                                }}
                              >
                                {getToGradeArray(
                                  formState.from_grade,
                                  globalState.grade_details?.grade ?? {},
                                ).map((option) => (
                                  <MenuItem
                                    key={`gradeArray2${option.key}`}
                                    value={option.key}
                                  >
                                    {option.value}
                                  </MenuItem>
                                ))}
                              </TextField>
                              <FormHelperText>
                                {formErrors.to_grade}
                              </FormHelperText>
                            </FormControl>
                          </div>
                        </div>
                      </div>
                      <div className="edit-course-date-and-price-container">
                        <div className="edit-Course-inner-input Course-Start-Date">
                          <label>Course Start Date</label>
                          <FormControl
                            className="edit-course-form-control"
                            margin="none"
                            fullWidth
                            error={!!formErrors.start_date}
                          >
                            <DesktopDatePicker
                              name="start_date"
                              className="edit-course-input-fields"
                              variant="outlined"
                              value={dayjs(formState.start_date)}
                              minDate={dayjs()}
                              error={!!formErrors.start_date}
                              onChange={(date) =>
                                handleInputChangedate("start_date", date)
                              }
                              slots={{ openPickerIcon: CalendarMonthIcon }}
                              open={open1}
                              onClose={() => setopen1(false)}
                              onOpen={() => setopen1(true)}
                              onKeyDown={(e) => {
                                e.preventDefault();
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  onKeyDown={(e) => e.preventDefault()}
                                  InputProps={{
                                    ...params.InputProps,
                                    sx: {
                                      borderRadius: "6px",
                                      backgroundColor: "#FFFFFF",
                                    },
                                  }}
                                  onClick={() => setopen1(true)}
                                  size="small"
                                />
                              )}
                              slotProps={{
                                field: { setopen1 },
                                inputAdornment: {
                                  position: "start",
                                },
                                error: !!formErrors.start_date,
                                textField: {
                                  error: false,
                                  onClick: () => setopen1(true),
                                  size: "small",
                                  InputProps: {
                                    sx: {
                                      borderRadius: "6px",
                                      backgroundColor: "#FFFFFF",
                                    },
                                  },
                                },
                              }}
                            />

                            <FormHelperText>
                              {formErrors.start_date}
                            </FormHelperText>
                          </FormControl>
                        </div>
                        <div
                          className="edit-Course-inner-input Course-Start-Date"
                          id="edit-course-end-date"
                        >
                          <label>
                            Course End Date <span>(Optional)</span>
                          </label>
                          {formState.end_date && (
                            <i
                              onClick={() => resetEndDate()}
                              className="fa-solid fa-x"
                            ></i>
                          )}
                          <FormControl
                            className="edit-course-form-control"
                            margin="none"
                            fullWidth
                            error={!!formErrors.end_date}
                          >
                            <DesktopDatePicker
                              name="end_date"
                              className="edit-course-input-fields"
                              variant="outlined"
                              value={
                                formState.end_date === ""
                                  ? null
                                  : dayjs(formState.end_date)
                              }
                              error={!!formErrors.end_date}
                              onChange={(date) =>
                                handleInputChangedate("end_date", date)
                              }
                              slots={{ openPickerIcon: CalendarMonthIcon }}
                              open={open2}
                              onOpen={() => setopen2(true)}
                              onClose={() => setopen2(false)}
                              minDate={dayjs(formState.start_date)?.add(
                                1,
                                "day",
                              )}
                              onKeyDown={(e) => {
                                e.preventDefault();
                              }}
                              renderInput={(params) => (
                                <TextField
                                  className="edit-course-input-fields"
                                  {...params}
                                  onKeyDown={(e) => e.preventDefault()}
                                  InputProps={{
                                    ...params.InputProps,
                                    sx: {
                                      borderRadius: "6px",
                                      backgroundColor: "#FFFFFF",
                                    },
                                  }}
                                  onClick={() => setopen2(true)}
                                  size="small"
                                />
                              )}
                              slotProps={{
                                field: { setopen2 },
                                inputAdornment: {
                                  position: "start",
                                },
                                textField: {
                                  onClick: () => setopen2(true),
                                  size: "small",
                                  InputProps: {
                                    sx: {
                                      borderRadius: "6px",
                                      backgroundColor: "#FFFFFF",
                                    },
                                  },
                                },
                              }}
                            />
                            <FormHelperText>
                              {formErrors.end_date}
                            </FormHelperText>
                          </FormControl>
                        </div>
                        {globalState.enabled_modules?.includes("marketplace") &&
                          !globalState.subdomain_exists && (
                            <>
                            <div className="course-toggle-uplode-folder">
                              <div className="monetize-course-input-toggle">
                                <div className="restriction-iocn">
                                  <label>Monetize Course</label>
                                  <img
                                    src={restrichtion_icon}
                                    data-tooltip-id="monetize-course"
                                  />
                                </div>
                                <span
                                  className="monetize-course-input-toggle-folder"
                                  style={{
                                    height: "38px",
                                    marginBottom: "29px",
                                  }}
                                >
                                  <p>{isMonetizeEnabled ? "On" : "Off"}</p>
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      checked={isMonetizeEnabled}
                                      onClick={handleSwitchToggle}
                                    />
                                    <span className="slider round"></span>
                                  </label>
                                </span>
                                <Tooltip
                                  id="monetize-course"
                                  place="top"
                                  content={
                                    "Enable this toggle to display course monetization options."
                                  }
                                  type="light"
                                  effect="float"
                                />
                              </div>
                                                                                    {isMonetizeEnabled && isValidDomain && globalState.enabled_modules?.includes("toggle_button") && (
                                                      <div className="Create-Course-inner-input create-course-inner-input-grade domain-field-column"  id="courseMonetize"
                            >
                                                        <label id="courseDate">Free for specific domain</label>

                                                        <ClickAwayListener onClickAway={() => setShowDropdown(false)}>
                                                          <div className="domain-dropdown">
                                                            <TextField
                                                              name="free_domains"
                                                              className="edit-course-input-fields domain-select-field"
                                                              placeholder=" Select Domain"
                                                              variant="outlined"
                                                              size="small"
                                                              fullWidth
                                                              value={selectedDomains.join(", ")}
                                                              onClick={() => setShowDropdown((prev) => !prev)}
                            
                            
                                                              InputProps={{
                                                                readOnly: true,
                                                                endAdornment: (
                                                                  <ArrowDropDownIcon
                                                                    className={`domain-dropdown-arrow ${showDropdown ? "open" : ""}`}
                                                                    sx={{ color: "rgba(0, 0, 0, 0.54)" }}
                                                                  />
                                                                ),
                                                                sx: {
                                                                  borderRadius: "6px",
                                                                  backgroundColor: "#FFFFFF",
                                                                  cursor: "pointer",
                                                                },
                                                              }}
                                                            />
                            
                            
                                                            {showDropdown && (
                                                              <div className="domain-checkbox-container">
                                                                {/* Select All */}
                            
                                                                <div className="checkbox-row">
                                                                  <input
                                                                    type="checkbox"
                                                                    id="select-all"
                                                                    checked={
                                                                      freedomain.length > 0 &&
                                                                      selectedDomains.length === freedomain.length
                                                                    }
                                                                    onChange={handleSelectAll}
                                                                  />
                                                                  <label htmlFor="select-all">Select All</label>
                                                                </div>
                            
                                                                <hr />
                            
                                                                {freedomain.map((domain) => (
                                                                  <div className="checkbox-row" key={domain}>
                                                                    <input
                                                                      type="checkbox"
                                                                      id={domain}
                                                                      checked={selectedDomains.includes(domain)}
                                                                      onChange={() => handleCheckboxChange(domain)}
                                                                    />
                                                                    <label htmlFor={domain}>{domain}</label>
                                                                  </div>
                                                                ))}
                                                              </div>
                                                            )}

                                                          </div>
                                                        </ClickAwayListener>
                            
                                                          </div>
                                                                                        )}
                            </div>

                            
                                                  </>
                            
                          )}
                      </div>
                      {globalState.enabled_modules?.includes("marketplace") &&
                        isMonetizeEnabled &&
                        !globalState.subdomain_exists && (
                          <div className="Create-Course-disscount-wrapper">
                            <div
                              className="Create-Course-inner-input"
                              style={{ width: "18%" }}
                            >
                              <label>
                                Course Price ({currency_symbol ?? ""})
                              </label>
                              <FormControl
                                className="edit-course-form-control"
                                margin="none"
                                fullWidth
                                error={!!formErrors.price}
                              >
                                <TextField
                                  type="number"
                                  name="price"
                                  placeholder={`E.g. 100`}
                                  variant="outlined"
                                  className="edit-course-input-fields"
                                  size="small"
                                  value={formState.price}
                                  error={!!formErrors.price}
                                  onChange={handleInputChange}
                                  onInput={(e) => {
                                    const value = e.target.value;
                                    // Allow only up to 2 decimal places
                                    if (value.includes(".")) {
                                      const parts = value.split(".");
                                      if (parts[1]?.length > 2) {
                                        e.target.value = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                      }
                                    }
                                  }}
                                  InputProps={{
                                    startAdornment: (
                                      <span
                                        style={{
                                          marginLeft: "0px",
                                          color: "#1A1A1A",
                                        }}
                                      >
                                        {currency_symbol ?? ""}
                                      </span>
                                    ),
                                    sx: {
                                      borderRadius: "6px",
                                      backgroundColor: "#FFFFFF",
                                    },
                                    inputProps: {
                                      min: 0,
                                      step: "0.01",    // ← allows 2 decimal input via arrows
                                    },
                                  }}
                                />
                                <FormHelperText>
                                  {formErrors.price}
                                </FormHelperText>
                              </FormControl>
                            </div>
                            <div
                              className="Create-Course-inner-input"
                              style={{ width: "17%" }}
                              id="courseMonetize"
                              data-tooltip-id={ currency_symbol === "$" &&
                                    Number(formState.price) === 1 ? "course-discount-price" : null }

                            >
                              <label>Course Discount %</label>
                              <FormControl
                                className="edit-course-form-control"
                                margin="none"
                                fullWidth
                                error={!!formErrors.discount_percentage}
                              >
                                <Autocomplete
                                  disabled={
                                    currency_symbol === "$" &&
                                    Number(formState.price) === 1
                                  }
                                  value={
                                    formState.discount_percentage
                                      ? `${formState.discount_percentage}%`
                                      : null
                                  }
                                  onChange={(event, newValue) => {
                                    // Security: use regex /g flag so ALL '%' chars are removed (not just first occurrence)
                                    const numericValue = newValue
                                      ? String(newValue).replace(/%/g, "")
                                      : "";
                                    handleInputChange({
                                      target: {
                                        name: "discount_percentage",
                                        value: numericValue,
                                      },
                                    });
                                  }}
                                  id="discount_percentage"
                                  options={transformedDiscountArr}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      name="discount_percentage"
                                      placeholder="E.g. 5%"
                                      variant="outlined"
                                      size="small"
                                      className="edit-course-input-fields"
                                      error={!!formErrors.discount_percentage}
                                      helperText={
                                        formErrors.discount_percentage || ""
                                      }
                                      InputProps={{
                                        ...params.InputProps,
                                        sx: {
                                          borderRadius: "6px",
                                          backgroundColor: "#FFFFFF",
                                          textTransform: "capitalize",
                                          marginBottom: "20px",
                                        },
                                      }}
                                    />
                                  )}
                                  sx={{
                                    "& .MuiAutocomplete-listbox": {
                                      textTransform: "capitalize",
                                    },
                                  }}
                                />
                              </FormControl>
                                   <Tooltip
                                id="course-discount-price"
                                place="top"
                                content="Discounts are not applicable to $1 course."
                                type="light"
                                effect="float"
                                style={{
                                  maxWidth: "250px",
                                  marginBottom: "5px",
                                }}
                              />
                            </div>
                            <div
                              className="Create-Course-inner-input"
                              style={{ width: "25%" }}
                              id="courseMonetize"
                            >
                              <div>
                                <div className="restriction-iocn" style={{ display: "flex" }}>
                                  <label>
                                    Price After Discount ({currency_symbol ?? ""})
                                  </label>
                                  <img
                                    src={restrichtion_icon}
                                    data-tooltip-id="discount-price"
                                  />
                                </div>
                                <span className="course-discount-input">
                                  <p>
                                    {currency_symbol} {discountedAmt}

                                    {Number(roundOffValue) !== 0 && (
                                      <span style={{ color: "#666", fontSize: "12px", marginLeft: "8px" }}>
                                        = {currency_symbol}
                                        {actualDiscountAmt.toFixed(2)}
                                        {" "}
                                        {Number(roundOffValue) > 0 ? "+" : "-"}
                                        {" "}
                                        {currency_symbol}
                                        {Math.abs(Number(roundOffValue)).toFixed(2)} (round off value)
                                      </span>
                                    )}
                                  </p>
                                </span>
                              </div>
                              {/* <div className="restriction-iocn">
                                <label>
                                  Price After Discount ({currency_symbol ?? ""})
                                </label>
                                <img
                                  src={restrichtion_icon}
                                  data-tooltip-id="discount-price"
                                />
                              </div>
                              <span className="course-discount-input">
                                <p>
                                  {" "}
                                  {currency_symbol ?? ""} {discountedAmt}
                                </p>
                              </span> */}
                              <div className="absolute text-[11px]" style={{ bottom: "-34px" }}>
                                {formState.price && formErrors.discounted_price && (
                                  <FormHelperText error className="!text-[11px]">{formErrors.discounted_price}</FormHelperText>
                                )}
                              </div>
                              <Tooltip
                                id="discount-price"
                                place="top"
                                content={
                                  <>
                                    Course Price after discount will be{" "}
                                    {formState.discount_percentage !== "" && (
                                      <span
                                        style={{
                                          textDecoration: "line-through",
                                        }}
                                      >
                                        {currency_symbol ?? ""}
                                        {formState.price ? formState.price : 0}
                                      </span>
                                    )}{" "}
                                    {currency_symbol ?? ""}
                                    {discountedAmt ? discountedAmt : 0}
                                  </>
                                }
                                type="light"
                                effect="float"
                                style={{
                                  maxWidth: "250px",
                                  marginBottom: "5px",
                                }}
                              />
                            </div>
                            <div
                              className="Create-Course-inner-input"
                              style={{ width: "16%" }}
                              id="courseMonetize"
                            >
                              <div className="restriction-iocn">
                                <label>Platform Fee</label>
                                <img
                                  src={restrichtion_icon}
                                  data-tooltip-id="course-platform-fee"
                                />
                              </div>
                              <span className="course-discount-input">
                                <p>
                                  {currency_symbol ?? ""} {commission}
                                </p>
                              </span>
                              <Tooltip
                                id="course-platform-fee"
                                place="top"
                                content={`Note: ProSchool charges a ${Number(platformfee) || 0}% commission per course sale to support platform enhancement and operation.`}
                                type="light"
                                effect="float"
                                style={{
                                  maxWidth: "250px",
                                  marginBottom: "5px",
                                }}
                              />
                            </div>
                            <div
                              className="Create-Course-inner-input"
                              style={{ width: "16%" }}
                              id="courseMonetize"
                            >
                              <div className="restriction-iocn">
                                <label>What you get</label>
                                <img
                                  src={restrichtion_icon}
                                  data-tooltip-id="course-What-you-get"
                                />
                              </div>
                              <span className="course-discount-input">
                                <p>
                                  {currency_symbol ?? ""} {finalAmt}
                                </p>
                              </span>
                              <Tooltip
                                id="course-What-you-get"
                                place="top"
                                content="Note: Taxes and additional fees will be subtracted from the final payout amount."
                                type="light"
                                effect="float"
                                style={{
                                  maxWidth: "250px",
                                  marginBottom: "5px",
                                }}
                              />
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="edit-Course-inner-textarea">
                    <label>
                      Course Description{" "}
                      <span style={{ fontSize: "10px" }}>
                        (Character limit: {formState.description.length || 0}
                        /1000)
                      </span>
                    </label>
                    <FormControl
                      className="edit-course-form-control"
                      margin="none"
                      fullWidth
                      error={!!formErrors.description}
                      style={{ position: "relative" }}
                    >
                      <TextField
                        id="create-course-description"
                        name="description"
                        multiline
                        variant="outlined"
                        size="small"
                        className="edit-course-input-fields"
                        cols="30"
                        minRows={7}
                        value={formState.description || ""}
                        placeholder="Enter a short description about your course "
                        error={!!formErrors.description}
                        onChange={handleInputChange}
                        InputProps={{
                          sx: {
                            borderRadius: "6px",
                            backgroundColor: "#FFFFFF",
                          },
                          style: {
                            // floor, not a cap: the field grows with the text
                            minHeight: "160px",
                            height: "auto",
                            fontSize: "12px",
                            lineHeight: "20px",
                          },
                          inputProps: { maxLength: 1000 },
                        }}
                      />
                      <FormHelperText>{formErrors.description}</FormHelperText>
                      {waveloading && (
                        <div className="description-wave-loader">
                          <Waveform />
                        </div>
                      )}
                    </FormControl>
                  </div>
                  {loading ? (
                    <div className="loading-spinner" />
                  ) : (
                    <div className="edit-course-enhance-course-folder">
                      <button
                        className="enhance-text-edit-course"
                        style={{ border: "none", background: "transparent" }}
                      >
                        <EnhancedDescription
                          courseName={formState.name || ""}
                          subject={getSubjectData(course.subject || "")}
                          from_grade={formState.from_grade || ""}
                          to_grade={formState.to_grade || ""}
                          keywords={formState.description || ""}
                          error={!!formErrors.description}
                        />
                      </button>

                      <button
                        type="submit"
                        disabled={
                          waveloading || (isMonetizeEnabled && !formState.price)
                        }
                        style={{
                          backgroundColor:
                            (waveloading ||
                              (isMonetizeEnabled && !formState.price) ||
                              (isMonetizeEnabled &&
                                (!!formErrors.discounted_price ||
                                  !!formErrors.price))) &&
                            "grey",
                        }}
                        className={"Update-Publish-btn"}
                      >
                        Update and Publish
                      </button>
                    </div>
                  )}
                </div>
                <FloatingAIButton
                  onClick={() => {
                    dispatch(setDrawerState(!chatDrawerState.isOpen));
                    dispatch(setIsWebAllowed(true));
                    dispatch(setQueryMetaData(null));
                  }}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
      {modalIsOpen && (
        <CropProfileImageModal
          src={tempImage}
          setSrc={setTempImage}
          onSave={handleSaveCroppedImage}
          onCancel={handleCancelCroppedImage}
          setSelectedImage={setSelectedImage}
          setImageUploaded={setImageUploaded}
          setUplodedImage={setUplodedImage}
          modalStatus={modalIsOpen}
          setModalClose={onCloseModal}
          fieldName={"image"}
          setFormState={setFormState}
          formState={formState}
          aspectRatio={16 / 9}
        />
      )}
    </>
  );
};

export default EditCourseDetails;